import React from 'react';
import { MetricsCard } from '@/components/MetricsCard';
import { CampaignOverview } from '@/components/CampaignOverview';
import { ConversionFunnel } from '@/components/ConversionFunnel';
import { ActivityFeed } from '@/components/ActivityFeed';
import { 
  mockNurtureSequences, 
  mockConversionFunnel, 
  mockActivityEvents,
  mockDashboardMetrics 
} from '@/data/mockData';
import { Channel } from '@/types';
import { formatPercentage } from '@/utils';

interface OverviewProps {
  selectedChannel: Channel;
}

export const Overview: React.FC<OverviewProps> = ({ selectedChannel: _selectedChannel }) => {
  // Filter data by selected channel
  const filteredSequences = mockNurtureSequences.filter(_seq => {
    // In a real app, sequences would have channel associations
    return true; // For now, show all sequences
  });

  const metrics = mockDashboardMetrics;

  return (
    <div className="space-y-6 p-6">
      {/* Real-time Metrics Row */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        <MetricsCard
          title="Active Leads"
          value={metrics.activeLeads.total.toLocaleString()}
          change={{
            value: metrics.activeLeads.todayChange,
            label: 'today'
          }}
          description={`+${metrics.activeLeads.weeklyNew} new this week`}
        />
        <MetricsCard
          title="This Week"
          value={`+${metrics.activeLeads.weeklyNew} new`}
          description={`${metrics.activeLeads.weeklyStalled} stalled`}
        />
        <MetricsCard
          title="Handoffs"
          value={`${metrics.handoffs.ready} ready`}
          description={`${metrics.handoffs.pending} pending`}
        />
        <MetricsCard
          title="Response Rate"
          value={formatPercentage(metrics.responseRate.current)}
          change={{
            value: metrics.responseRate.weekOverWeekChange,
            label: 'vs last week'
          }}
        />
        <MetricsCard
          title="System Health"
          value={formatPercentage(metrics.systemHealth.uptime)}
          status={metrics.systemHealth.status === 'healthy' ? 'healthy' : 
                 metrics.systemHealth.status === 'degraded' ? 'warning' : 'critical'}
          description="All services operational"
        />
      </div>

      {/* Main content grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Active Campaigns - spans 2 columns */}
        <div className="lg:col-span-2">
          <CampaignOverview sequences={filteredSequences} />
        </div>

        {/* Activity Feed - spans 1 column */}
        <div>
          <ActivityFeed events={mockActivityEvents} />
        </div>
      </div>

      {/* Conversion Funnel - full width */}
      <div>
        <ConversionFunnel funnel={mockConversionFunnel} />
      </div>
    </div>
  );
};